import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser } from './FieldValueConverters'
import { Input } from 'reactstrap'

class TextAreaBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    rows: pt.number
  })

  render () {
    const { rows = 3, type, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading, readonly }) => {
          if (readonly) {
            return <Input type={'textarea'} rows={rows || 3} readOnly name={`view${name}`} id={`view${name}`} placeholder={placeHolder} value={value} />
          } else {
            return <Input type={'textarea'} rows={rows || 3} invalid={showError} name={`textarea${name}`} id={`textarea${name}`} placeholder={placeHolder} onChange={onChange} value={value} />
          }
        }}
      </FieldLayoutBox>
    )
  }
};

export const TextAreaBox = ({ parse, format, fieldType, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={TextAreaBoxClass} /> } // eslint-disable-line
export default TextAreaBox
